import React from "react";
import { Route } from "react-router-dom";
import { RequireModuleAccess } from "../../app/session/RequireModuleAccess.js";
import PlansPage from "./pages/PlansPage.js";
import RequestsPage from "./pages/RequestsPage.js";
import SubscriptionsPage from "./pages/SubscriptionsPage.js";
import TenantBillingPage from "./pages/TenantBillingPage.js";

export const finanzasRoutes = (
  <Route element={<RequireModuleAccess module="finanzas" />}>
    <Route path="/planes" element={<PlansPage />} />
    <Route path="/suscripciones" element={<SubscriptionsPage />} />
    <Route path="/solicitudes" element={<RequestsPage />} />
    <Route path="/clientes/:id/facturacion" element={<TenantBillingPage />} />
  </Route>
);
